import { render, staticRenderFns } from "./TenderOfferVersionDropdownInfo.vue?vue&type=template&id=0e97a740&scoped=true&"
import script from "./TenderOfferVersionDropdownInfo.vue?vue&type=script&lang=js&"
export * from "./TenderOfferVersionDropdownInfo.vue?vue&type=script&lang=js&"
import style0 from "./TenderOfferVersionDropdownInfo.vue?vue&type=style&index=0&id=0e97a740&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e97a740",
  null
  
)

export default component.exports